export const OPEN_MODAL = 'Open modal';
export const CLOSE_MODAL = 'Close modal';
export const CLOSE_ALL_MODALS = 'Close all modals';
export const PUSH_MODAL = 'Push modal';
export const ADD_MODAL_PROPS = 'Add modal props';
